exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".steps {\n  margin-top: 30px;\n  text-align: center; }\n  .steps > i {\n    color: #6b6b6b; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Setup/components/scss/steps.scss
// module id = 898
// module chunks = 1